import useGetImages from "../hooks/useGetImages";
import { useTheme } from "../context/ThemeContext";

const CategoryItem = ({ item, filterProducts, id, chooseCategory }) => {
  const theme = useTheme();
  const { image: uri, isLoading } = useGetImages("category_pictures", id, item?.CATEGORY);

  return (
    <div
      className={uri ? "w-48 keen-slider__slide" : "w-64 keen-slider__slide"}
      onClick={() => filterProducts(item?.CATEGORY)}
    >
      {isLoading ? (
        <div className="animate-pulse">
          <div className="w-full h-20 rounded-md bg-gray-200"></div>
          <div className="mt-2 h-4 rounded-md bg-gray-200 mx-auto w-3/4"></div>
        </div>
      ) : uri ? (
        <>
          <img src={uri} className="w-full h-20 rounded-md object-cover" alt={item?.CATEGORY} />
          <p
            className={
              chooseCategory === item?.CATEGORY
                ? `mt-2 font-bold text-sm text-center ${theme.primary.text}`
                : "mt-2 font-bold text-sm text-center text-zinc-500"
            }
          >
            {item?.CATEGORY}
          </p>
        </>
      ) : (
        <div
          className={
            chooseCategory === item?.CATEGORY
              ? `w-full h-20 rounded-md ${theme.primary.bg} flex items-center justify-center px-4 py-2`
              : `w-full h-20 rounded-md ${theme.category?.bg || 'bg-zinc-200'} flex items-center justify-center px-4 py-2`
          }
        >
          <p
            className={
              chooseCategory === item?.CATEGORY
                ? "font-bold text-xs text-white text-center leading-tight"
                : "font-bold text-xs text-zinc-600 text-center leading-tight"
            }
            style={{ wordBreak: 'keep-all', overflowWrap: 'normal' }}
          >
            {item?.CATEGORY}
          </p>
        </div>
      )}
    </div>
  );
};
export default CategoryItem;
